/** @jsx $jsx */
import { $jsx } from 'framework7';
import { setup } from '../../js/sandbox_scripts/cache';
export default (function (props, _ref) {
  var $f7 = _ref.$f7,
      $on = _ref.$on,
      $store = _ref.$store;
  var loading = $store.getters.loading;
  var logs = $store.getters.logs;
  $on('pageInit', function (e, page) {
    setup();
    $store.dispatch('getLogs');
  });

  var loadLogs = function loadLogs() {
    $store.dispatch('getLogs');
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
    <div class="page" data-name="template">
        <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner sliding">
                <div class="title">Cache</div>
            </div>
        </div>
        <div class="page-content">
            <div class="container pt-4">
                <h3>Message Logs</h3>
                <!-- Cache List -->
                <div class="block-title">Intercepted Messages</div>
                <div class="card p-2">
                    ${logs.value.length > 0 ? $h`
                    <div class="list media-list">
                        <ul>
                            ${logs.value.map((log) => $h`
                            <li class="item-content">
                                <a href="#" class="item-link item-content">
                                    <div class="item-inner" style="width: 2000px">
                                        <div class="item-title-row">
                                            <div class="item-title">${log.topic}</div>
                                            <div class="item-after">
                                                ${new
                                                Date(log.timestamp).toLocaleString()}
                                            </div>
                                        </div>
                                        <div class="item-subtitle margin-bottom">
                                            ${log.type && log.type === 'in' ?
                                            <div class="chip color-blue">
                                                <div class="chip-label">Incoming</div>
                                            </div>
                                            : null} ${log.type && log.type === 'out' ?
                                            <div class="chip color-green">
                                                <div class="chip-label">Outgoing</div>
                                            </div>
                                            : null} ${log.type && log.type === 'sub' ?
                                            <div class="chip chip-outline color-blue">
                                                <div class="chip-label">Subscription</div>
                                            </div>
                                            : null} ${log.type && log.type === 'unsub' ?
                                            <div class="chip chip-outline color-red">
                                                <div class="chip-label">
                                                    Unsubscription
                                                </div>
                                            </div>
                                            : null}
                                        </div>
                                        <div class="item-text">${log.message}</div>
                                    </div>
                                </a>
                            </li>
                            `)}
                        </ul>
                    </div>
                    ` : $h`
                    <div class="block block-strong">
                        <a
                            href="#"
                            class="button button-fill button-preloader ${loading.value ? 'button-loading' : ''}"
                            @click="${loadLogs}"
                        >
                            <span class="preloader"></span>
                            <span>Load Logs</span>
                        </a>
                    </div>
                    `}
                </div>
            </div>
        </div>
    </div>
`
    }
    ;
});